import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MosquitoNetIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MosquitoNetIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.2574 10.3163C16.8746 9.17818 15.7506 8.25189 15.5157 6.77748H16.0557C16.3793 6.77748 16.6416 6.51514 16.6416 6.19154C16.6416 4.57611 15.3274 3.26185 13.7119 3.26185H13.126V2.67591C13.126 2.35232 12.8636 2.08997 12.54 2.08997C12.2164 2.08997 11.9541 2.35231 11.9541 2.67591V3.26185H11.3682C9.75274 3.26185 8.43848 4.57611 8.43848 6.19154C8.43848 6.51513 8.70082 6.77709 9.02442 6.77709H9.56442C9.32954 8.25147 8.20551 9.17815 6.82266 10.3163C4.78965 11.9895 2.54004 13.8883 2.54004 17.9884V21.5041C2.54004 21.8276 2.80238 22.09 3.12598 22.09H4.29786C4.45329 22.09 4.60231 22.0283 4.71216 21.9184L5.71244 20.9181H19.3677L20.3679 21.9184C20.4778 22.0283 20.6268 22.09 20.7823 22.09H21.9542C22.2777 22.09 22.5401 21.8277 22.5401 21.5041V17.9884C22.5401 14.1074 20.592 12.2377 18.2574 10.3163ZM17.5127 11.2211C19.2983 12.6907 21.1409 14.2077 21.3486 17.3834C15.1871 16.9924 13.3111 10.638 13.1394 6.77748H14.3325C14.5721 8.77608 15.9729 9.95377 17.5127 11.2211ZM6.98586 17.4025C9.24313 15.9684 10.9123 13.4636 11.9541 10.9996V17.4025H6.98586ZM13.126 12.2153C14.0014 14.3573 15.3852 16.2492 17.3801 17.4025H13.126V12.2153ZM11.3682 4.43372H13.7119C14.4759 4.43372 15.1275 4.92353 15.3693 5.6056H9.71074C9.95258 4.92353 10.6042 4.43372 11.3682 4.43372ZM7.56734 11.2211C9.11078 9.95083 10.508 8.77599 10.7476 6.77708H11.9235C11.5868 10.2152 8.49543 16.8422 3.73241 17.3689C3.94464 14.2031 5.78444 12.6885 7.56734 11.2211ZM21.3682 20.9181H21.0249L20.0247 19.9178C19.9148 19.808 19.7658 19.7462 19.6104 19.7462H5.46973C5.3143 19.7462 5.16528 19.808 5.05543 19.9178L4.05515 20.9181H3.71191V18.5744H21.3682L21.3682 20.9181Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MosquitoNetIcon;
